import { gql } from "@apollo/client";

import { CALL_PLAN_DETAIL } from "@/graphql-client/fragments";

export const GET_CALL_PLAN_DETAIL_QUERY = gql`
  query GetCallPlanDetail($callPlanId: Int!) {
    callPlan(id: $callPlanId) {
      ...CallPlanDetail
    }
  }
  ${CALL_PLAN_DETAIL}
`;
